module.exports = __webpack_public_path__ + "static/img/ball20.b5dba2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ball20.png
// module id = NRRD
// module chunks = 1